export default (DOMNode, to) => {
    DOMNode.scrollTo({
        top: to,
        behavior: "smooth",
    })
}